import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Home from '../views/Home';
import Application from '../views/Application';
import ApplicationDetail from '../views/ApplicationDetail';
import Products from '../views/Products';
import ProductDetail from '../views/ProductDetail';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/application/',
        name: 'application',
        component: Application,
        children: [
            {
                path: ':type',
                name: 'applicationDetail',
                component: ApplicationDetail,
                meta: { infoPanel: 'sections' },
                children: [
                    {
                        path: ':id',
                        component: ProductDetail,
                        meta: { infoPanel: 'products' }
                    }
                ]
            }
        ]
    },
    {
        path: '/products/',
        name: 'products',
        component: Products,
        children: [
            {
                path: ':id',
                name: 'productDetail',
                component: ProductDetail,
                meta: { infoPanel: 'products' }
            }
        ]
    }
];

const router = new VueRouter({
    mode: process.env.IS_ELECTRON ? 'hash' : 'history',
    routes
});

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
    let infoPanel = {};
    if (to.meta.infoPanel == 'sections' || to.meta.infoPanel == 'products') {
        infoPanel = {
            module: to.meta.infoPanel,
            name:
                to.meta.infoPanel == 'sections' ? to.params.type : to.params.id
        };
    }

    store.dispatch('setCurrentInfoPanel', infoPanel);
});

export default router;
